import { UserRole } from '@shared/utils/base-auth';
import { Observable } from 'rxjs';

export class UserHeading {
  constructor(public fullName: string, public role: UserRole, public imageUrl: string, public uid: string, public isNotificationBannerRead: boolean) {}
}

export abstract class PreviewUserHeadingServiceBase {
  abstract getUserData(): Observable<UserHeading>;

  abstract userImageChanged(value: string | null): void;

  abstract getUserRole(): Observable<UserRole>;
}
